module.exports = __webpack_public_path__ + "static/crater-app-discover-51b671929b75b1a0d426492d5471872c.jpg";